import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { AddressList } from './AddressList'
import { AddressForm} from './AddressForm'

let { ADDRESS } = window.PATH
export default class Address extends React.PureComponent {
  render () {
    return <Switch>
      <Route path={ADDRESS.LIST} component={AddressList} />
      <Route path={ADDRESS.FORM} component={AddressForm} />
      <Route path={ADDRESS.ADD} component={AddressForm} />
    </Switch>
  }
}
